module.exports = __webpack_public_path__ + "static/01-6cdcb35a52da76835da62cee43dff225.jpg";